import OnboardingLayout from '@/layouts/Onboarding.vue'

import TermsOfService from '@/views/onboarding/TermsOfService.vue'
import AdminOnboardingWelcome from '@/views/onboarding/admin/Welcome.vue'
import AdminOnboardingSetPassword from '@/views/onboarding/admin/SetPassword.vue'
import UserSetPassword from '@/views/onboarding/field-user/SetPassword.vue'
import PrivilegedOnboardingWelcome from '@/views/onboarding/privileged/Welcome.vue'
import PrivilegedOnboardingSetPassword from '@/views/onboarding/privileged/SetPassword.vue'

import AdminOnboardingGuard from '@/router/guards/admin-onboarding'
import PrivilegedOnboardingGuard from '@/router/guards/privileged-onboarding'

import store from '@/store'

export default [
    {
        path: '/onboarding',
        component: OnboardingLayout,
        children: [
            {
                path: 'terms-of-service',
                name: 'onboarding-terms-of-service',
                component: TermsOfService,
                beforeEnter: (to, from, next) => {
                    try {
                        const { user } = store.getters

                        if (user.accepted_terms) {
                            next('/')
                        } else {
                            next()
                        }
                    } catch (error) {
                        store.dispatch('logout')
                        next('login')
                    }
                },
            },
            {
                path: 'admin/:token',
                name: 'admin-onboarding',
                component: AdminOnboardingWelcome,
                beforeEnter: AdminOnboardingGuard,
            },
            {
                path: 'admin/:token/set-password',
                name: 'admin-onboarding-set-password',
                component: AdminOnboardingSetPassword,
                beforeEnter: AdminOnboardingGuard,
            },
            {
                path: 'privileged/:token',
                name: 'privileged-onboarding',
                component: PrivilegedOnboardingWelcome,
                beforeEnter: PrivilegedOnboardingGuard,
            },
            {
                path: 'privileged/:token/set-password',
                name: 'privileged-onboarding-set-password',
                component: PrivilegedOnboardingSetPassword,
                beforeEnter: PrivilegedOnboardingGuard,
            },
            {
                path: 'field-user/:token/set-password',
                name: 'field-user-onboarding-set-password',
                component: UserSetPassword,
            },
        ],
    },
]
